import React from 'react';
import { SvgSizeClassProps } from '../interfaces';

const SVGFightWin = ({ size = 247, className }: SvgSizeClassProps) => (
  <svg
    width={size}
    height={size * 0.64}
    viewBox='0 0 247 159'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M56.5271 127.842V48.3804L70.6589 45.3766V132.062L63.593 133.564V140.787L56.5271 142.289V149.513L42.3954 152.517V145.293L28.2636 148.297V155.521L14.1318 158.524V151.301L7.06589 152.802V145.579L0 147.081V60.3956L14.1318 57.3918V136.853L28.2636 133.849V97.7305L42.3954 94.7267V130.845L56.5271 127.842Z'
      fill='#321E68'
    />
    <path
      d='M98.8673 53.8283V39.3808L141.263 30.3694V44.8169L127.131 47.8207V120.058L141.263 117.054V131.502L98.8673 140.513V126.066L112.999 123.062V50.8245L98.8673 53.8283Z'
      fill='#321E68'
    />
    <path
      d='M225.998 70.1483V12.3583L240.13 9.35447V110.487L225.998 113.491V91.8195L218.932 93.3214V86.0977L211.866 87.5996V80.3758L204.8 81.8777V74.654L197.735 76.1559V68.9321L190.669 70.434V63.2103L183.603 64.7122V122.502L169.471 125.506V24.3735L183.603 21.3697V43.0409L190.669 41.539V48.7628L197.735 47.2609V54.4846L204.8 52.9827V60.2065L211.866 58.7046V65.9283L218.932 64.4264V71.6502L225.998 70.1483Z'
      fill='#321E68'
    />
    <path
      d='M62.7754 118.487V39.0259L76.9072 36.0221V122.707L69.8413 124.209V131.433L62.7754 132.935V140.158L48.6437 143.162V135.938L34.5119 138.942V146.166L20.3801 149.17V141.946L13.3142 143.448V136.224L6.24832 137.726V51.0411L20.3801 48.0373V127.499L34.5119 124.495V88.376L48.6437 85.3722V121.491L62.7754 118.487Z'
      fill='#4EABF4'
    />
    <path
      d='M105.116 44.4738V30.0263L147.511 21.0148V35.4623L133.379 38.4661V110.704L147.511 107.7V122.147L105.116 131.159V116.711L119.247 113.707V41.47L105.116 44.4738Z'
      fill='#4EABF4'
    />
    <path
      d='M232.246 60.7938V3.00377L246.378 -4.05812e-05V101.132L232.246 104.136V82.465L225.181 83.9669V76.7432L218.115 78.2451V71.0213L211.049 72.5232V65.2995L203.983 66.8014V59.5776L196.917 61.0795V53.8558L189.851 55.3577V113.148L175.719 116.151V15.019L189.851 12.0152V33.6864L196.917 32.1845V39.4083L203.983 37.9064V45.1301L211.049 43.6282V50.852L218.115 49.3501V56.5738L225.181 55.0719V62.2957L232.246 60.7938Z'
      fill='#4EABF4'
    />
  </svg>
);

export default SVGFightWin;
